var map = {
	"./crop": 2147,
	"./crop.tsx": 2147,
	"./field": 8521,
	"./field.tsx": 8521,
	"./location": 1508,
	"./location.tsx": 1508,
	"./planting": 6980,
	"./planting.tsx": 6980,
	"./prolongedPlanting": 9128,
	"./prolongedPlanting.tsx": 9128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7193;